/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseImageFieldType = {
    IconImageType: 'IMAGE_FIELD_ICON_IMAGE_TYPE',
    UploadedImageType: 'IMAGE_FIELD_UPLOADED_IMAGE_TYPE',
    DerivedFaviconType: 'IMAGE_FIELD_DERIVED_FAVICON_TYPE'
} as const;
export type DatabaseImageFieldType = typeof DatabaseImageFieldType[keyof typeof DatabaseImageFieldType];


export function DatabaseImageFieldTypeFromJSON(json: any): DatabaseImageFieldType {
    return DatabaseImageFieldTypeFromJSONTyped(json, false);
}

export function DatabaseImageFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageFieldType {
    return json as DatabaseImageFieldType;
}

export function DatabaseImageFieldTypeToJSON(value?: DatabaseImageFieldType | null): any {
    return value as any;
}

